import {
  CONSUMER_TRACKING_KEY,
  type ConsumerTrackingRef,
} from "./types"

// Tiny localStorage helper for the returning-consumer tracking pointer. After
// a successful intake we stash the opaque trackToken here so a return visit to
// /go/:shopId (same device) can offer "resume your repair" without needing the
// texted link. Read by the tracking page + welcome resume affordance.

export function saveTrackingRef(ref: ConsumerTrackingRef) {
  try {
    localStorage.setItem(CONSUMER_TRACKING_KEY, JSON.stringify(ref))
  } catch {
    // Quota / disabled storage — the SMS link is the real source of truth.
  }
}

export function readTrackingRef(): ConsumerTrackingRef | null {
  try {
    const raw = localStorage.getItem(CONSUMER_TRACKING_KEY)
    if (!raw) return null
    const ref = JSON.parse(raw) as ConsumerTrackingRef
    if (!ref.trackToken || !ref.estimateId) return null
    return ref
  } catch {
    return null
  }
}

export function clearTrackingRef() {
  try {
    localStorage.removeItem(CONSUMER_TRACKING_KEY)
  } catch {
    // ignore
  }
}
